import React from 'react';
import { Author } from '../types/Newsletter';
import AuthorAndTopicCard from './AuthorAndTopicCard';
import Button from '../../components/buttons/SimpleButton/Button';
import Dialog from '../../common/components/Dialog';
import AuthorDetailsDialogContent from './AuthorDetailsDialogContent';

interface AuthorAndTopicSuggestionProps {
  suggestedArticlesOrTopics: Author[];
  type: 'author' | 'topic';
  text: string;
  followAllButtonText: string;
  dialogOpenButtonText: string;
  onFollowClick: (id: number, type: 'author' | 'topic') => void;
  handleAuthorDialogOpen: () => void;
  followAllSuggested: () => void;
  openAuthorModal: (id: number) => void;
  openModalId: number | null;
  closeAuthorModal: () => void;
}

export default function AuthorAndTopicSuggestion({
  suggestedArticlesOrTopics,
  type,
  text,
  followAllButtonText,
  dialogOpenButtonText,
  onFollowClick,
  handleAuthorDialogOpen,
  followAllSuggested,
  openAuthorModal,
  openModalId,
  closeAuthorModal,
}: AuthorAndTopicSuggestionProps) {
  return (
    <div className="followed-content__section-wrapper">
      <div className="follow-suggestion-box follow-suggestion-box--authors">
        <p className="follow-suggestion-box__text basic-16">{text}</p>
        <div className="follow-suggestion-box__button-container">
          <Button
            className="follow-suggestion-box__button follow-suggestion-box__button--follow-all author"
            label={followAllButtonText}
            type="primary"
            size="medium"
            onClick={() => followAllSuggested()}
          />

          <Button
            id="follow-suggestion-box--authors"
            className="follow-suggestion-box__button follow-suggestion-box__button--search"
            label={dialogOpenButtonText}
            type="secondary"
            size="medium"
            onClick={() => handleAuthorDialogOpen()}
          />
        </div>
      </div>

      <div className="followed-content__grid followed-content__grid--authors">
        {suggestedArticlesOrTopics.map((item: Author) => (
          <React.Fragment key={item.id}>
            <AuthorAndTopicCard
              title={item.name}
              id={item.id.toString()}
              type={type}
              isFollowed={false}
              link={item.link}
              imageUrl={type === 'author' ? (item.acf?.profileImageUrl ?? '') : (item.acf?.newsletter_image ?? '')}
              name={item.name}
              description={item.description}
              shortDescription={item.acf?.shortDescription ?? ''}
              onFollowClick={(id: number, type: 'author' | 'topic') => {
                onFollowClick(id, type);
              }}
              layout={'followed-authors'}
              isFollowable={true}
              nameType={type === 'author' ? 'button' : 'link'} // if it's a topic it should be a link
              openAuthorModal={() => openAuthorModal(item.id)}
            />
            <Dialog isOpen={openModalId === item.id} onClose={closeAuthorModal}>
              <AuthorDetailsDialogContent
                id={item.id.toString()}
                authorName={item.name}
                authorImageUrl={item.acf?.profileImageUrl ?? ''}
                authorTitle={item.name}
                authorDescription={item.description}
                authorLink={item.link}
                onFollowClick={(id: number, type: 'author' | 'topic') => onFollowClick(id, type)}
                isFollowed={false}
                hasSocialLinks
                linkedin={item.acf?.linkedin_url ?? ''}
                instagram={item.acf?.instagram_url ?? ''}
                twitter={item.acf?.twitter_url ?? ''}
                email={item.acf?.author_email ?? ''}
                isFollowable={true}
                onClose={closeAuthorModal}
              />
            </Dialog>
          </React.Fragment>
        ))}
      </div>
    </div>
  );
}
